var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-connections-list-filter"},[_c('common-filter',{attrs:{"title":_vm.$t('pages.network.connections.filters.title'),"options":_vm.filterOptions},on:{"filter-changed":_vm.filterChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }